import { BaseListComponent } from './components/base-list/base-list.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { CommonModule } from '@angular/common';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { CustomFilterComponent } from './components/custom-filter/custom-filter.component';
import { CustomFilterDirective } from './directives/custom-filter.directive';
import { FormTrackChangesDirective } from './directives/form-track-changes.directive';
import { FullDateTimePipe } from './pipes/full-date-time.pipe';
import { FullTimePipe } from './pipes/full-time.pipe';
import { LoginComponent } from './components/login/login.component';
import { LogoComponent } from './components/logo/logo.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MaximizableFormComponent } from './components/maximizable-form/maximizable-form.component';
import { MenuComponent } from './components/menu/menu.component';
import { NgModule } from '@angular/core';
import { PictureComponent } from './components/picture/picture.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RegisterComponent } from './components/register/register.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { RouterModule } from '@angular/router';
import { SidenavMenuComponent } from './components/sidenav-menu/sidenav-menu.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { StopwatchComponent } from './components/stopwatch/stopwatch.component';
import { SuccessDialogComponent } from './components/success-dialog/success-dialog.component';
import { SwitchTenantsComponent } from './components/switch-tenants/switch-tenants.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    BaseListComponent,
    ChangePasswordComponent,
    ConfirmationModalComponent,
    CustomFilterComponent,
    CustomFilterDirective,
    FormTrackChangesDirective,
    FullDateTimePipe,
    FullTimePipe,
    LoginComponent,
    LogoComponent,
    MaximizableFormComponent,
    MenuComponent,
    PictureComponent,
    RegisterComponent,
    ResetPasswordComponent,
    SidenavMenuComponent,
    SpinnerComponent,
    StopwatchComponent,
    SwitchTenantsComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatMomentDateModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    ReactiveFormsModule,
    RouterModule,
    SuccessDialogComponent,
    TranslateModule
  ],
  exports: [
    BaseListComponent,
    ChangePasswordComponent,
    FormTrackChangesDirective,
    FullDateTimePipe,
    FullTimePipe,
    LoginComponent,
    LogoComponent,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatSelectModule,
    MatSnackBarModule,
    MatTabsModule,
    MatTooltipModule,
    MaximizableFormComponent,
    MenuComponent,
    PictureComponent,
    ReactiveFormsModule,
    RegisterComponent,
    ResetPasswordComponent,
    SidenavMenuComponent,
    SpinnerComponent,
    StopwatchComponent,
    TranslateModule
  ],
  providers: [
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB'
    },
    {
      provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
      useValue: {
        useUtc: true
      }
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline'
      }
    }
  ]
})
export class SharedModule { }